/** Пример значений данных получаемых из сервисов Liferay
 * Сервис http://62.61.8.56:8080/api/jsonws/wiki.wikipage/get-node-pages/node-id/33945/max/100
 * {
 *    "companyId": "20101",
 *    "content": "== Описание ==\n\nResource Description Framework (RDF, «среда описания ресурса»~[1~]) — это ра
 *    "createDate": 1586184185442,
 *    "format": "creole",
 *    "groupId": "20124",
 *    "head": true,
 *    "lastPublishDate": null,
 *    "minorEdit": false,
 *    "modifiedDate": 1586268293195,
 *    "mvccVersion": "3",
 *    "nodeId": "33945",
 *    "pageId": "37265",
 *    "parentTitle": "",
 *    "redirectTitle": "",
 *    "resourcePrimKey": "36820",
 *    "status": 0,
 *    "statusByUserId": "33501",
 *    "statusByUserName": "Test Test",
 *    "statusDate": 1586268292848,
 *    "summary": "",
 *    "title": "RDF",
 *    "userId": "33501",
 *    "userName": "Test Test",
 *    "uuid": "f9d5178f-d245-ca9f-18d7-31951ebe11a7",
 *    "version": 1.3
 *  }
 * 
 */
import { WIKI } from '../../const/C';

/** Обрезка содержимого wiki статьи для поля description*/
export const pruningContent = textWiki => {
  return (textWiki)? textWiki.substring(WIKI.CONTENT_PRUNING_SIZE):"";
}

/** Формирует URI wiki статьи. Используется IRI актива и pageId страницы из ответа JSON */
export const makeIRIPage = (asset, page) => {
  return asset+"_wiki_"+page.pageId;
}

/** Формирует наполнение поля Description. На основе значений поля summary, а при отсутствии content */
export const makeDescription = page => {
  return (page.summary)? page.summary: pruningContent(page.content);
}

/** Формируется URL на страницу в Liferay */
export const makeURL = (nodes, page) => {
  const nodeName = (nodes && Array.isArray(nodes) && nodes.length>0)? nodes[0].name:"Wiki";
  return encodeURI("http://62.61.8.56:8080/web/guest/wiki/-/wiki/"+nodeName+"/"+page.title);
}

/** Вычленить последнее значение в iri, для получения наименование статьи по последей части URL */
export const getLastSectionPath = (iri) =>{
  if (iri){
    const lastIndexOf = Math.max(iri.lastIndexOf("#"), iri.lastIndexOf("/"))+1;
    if (lastIndexOf>1) return iri.substring(lastIndexOf);
  }
  return iri;
}
